export enum enPlanType {
  anual = 'a',
  mensal = 'm'
}
